"use client";

import { queueSkipsSchema } from "../../../../lib/types/schema/queue/queueSkipsSchema";
import type { UseRequestProps } from "../../../../request/hooks/useRequest";
import { useRequestMutation } from "../../../../request/hooks/useRequestMutation";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyQueueSkips } from "./keyQueueSkips";

export type UseRequestQueueSkipsProps = UseRequestProps;

export const useRequestQueueSkips = ({
  ...props
}: UseRequestQueueSkipsProps = {}) => ({
  mutatePost: useRequestMutation<typeof queueSkipsSchema>({
    ...props,
    mutationFnRequestProps: () => ({
      method: "POST",
      schema: queueSkipsSchema,
      urlBackendPath: "/queue/skips",
    }),
  }),
  query: useRequestQuery({
    enabledWithoutSessionToken: false,
    queryKey: keyQueueSkips(),
    queryFnRequestProps: {
      schema: queueSkipsSchema,
      urlBackendPath: "/queue/skips",
    },
  }),
});
